import { render } from "./ApplicationManagement.vue?vue&type=template&id=15d3b915"
import script from "./ApplicationManagement.vue?vue&type=script&lang=js"
export * from "./ApplicationManagement.vue?vue&type=script&lang=js"

import "./ApplicationManagement.vue?vue&type=style&index=0&id=15d3b915&lang=css"

import exportComponent from "D:\\wanlin-cloud-platform-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__